export const FORM_USER_IDENTIFICATION_TEXTS = {
  FIELD_DOCUMENT_TYPE: {
    FIELD_TEXT: `Tipo de documento`
  },
  FIELD_DOCUMENT_NUMBER: {
    FIELD_TEXT: `Número de documento`,
    ERROR_MINLENGTH_TEXT: `Este campo debe tener mínimo 3 caracteres.`,
    RANGE_ERROR: `Documento inválido.`
  },
  FIELD_MOBILE_PHONE: {
    FIELD_TEXT: `Número de celular`,
    ERROR_MOBILE_FORMAT_TEXT: `El número de celular no es válido.`
  },
  FIELD_CONFIRM_MOBILE_PHONE: {
    FIELD_TEXT: `Confirma número de celular`,
    ERROR_NOT_EQUAL_TEXT: `Este celular no coincide.`
  },
  FIELD_FIRST_NAME: {
    FIELD_TEXT: `Primer nombre`
  },
  FIELD_SECOND_NAME: {
    FIELD_TEXT: `Segundo nombre (opcional)`
  },
  FIELD_FIRST_LAST_NAME: {
    FIELD_TEXT: `Primer apellido`
  },
  FIELD_SECOND_LAST_NAME: {
    FIELD_TEXT: `Segundo apellido (opcional)`
  },
  HABEAS_DATA_TEXT: `Autorizo al Banco AV Villas para que consulte y reporte mi información en centrales de riesgo y realice el tratamiento de mis datos personales.`,
  BUTTON_HABEAS_DATA_TEXT: `Ver más`,
  ERROR_RECAPTCHA_TEXT: `Tuvimos un error, inténtalo nuevamente.`
};

export const BUTTON_SUBMIT_TEXT = `Continuar`;
export const NEGATIVE_TEXT = `No`;
export const AFFIRMATIVE_TEXT = `Si`;
export const QUESTION_DIALOG_TEXT = `¿Qué es?`;
export const ERROR_REQUIRED_TEXT = `Este campo es obligatorio.`;
export const ERROR_EMPTY_FIELD = `Llena este campo para continuar.`;
export const ERROR_MIN_LEGTH = `Este campo debe tener mínimo 2 caracteres.`;
export const ERROR_MAX_LENGTH = `Este campo debe tener máximo 20 caracteres.`;
export const ERROR_MAIL_MAX_LENGTH = `Este campo debe tener máximo 254 caracteres.`;
export const ERROR_NOT_VALID_TEXT = `La información ingresada no es válida.`;
